/**
 * @file main.component.spec.ts
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main.component';
import { labels } from 'src/assets/doc/labels';
import { PmartPatientEnrollmentFormComponent } from '../shared/mail-order-patient-enrollment-form/mail-order-patient-enrollment-form.component';
import { MailOrderAccessGuard } from '../core/guards/mail-order/mail-order-access.guard';

const routes: Routes = [
  {
    path: '', component: MainComponent, children:
      [
        { path: '', redirectTo: 'home', pathMatch: 'full' },
        {
          path: 'home', title: labels.LABEL_BOTTOM_TABS_HOME,
          loadChildren: () => import('./home/home.module').then((m) => m.HomeModule)
        },
        {
          path: 'orders',
          loadChildren: () => import('./orders/orders.module').then((m) => m.OrdersModule),
          canActivate: [MailOrderAccessGuard]
        },
        {
          path: 'claims', title: labels.LABEL_BOTTOM_TABS_PHARMACY_CLAIMS,
          loadChildren: () => import('./claims/claims.module').then((m) => m.ClaimsModule)
        },
        {
          path: 'prescriptions', title: labels.LABEL_BOTTOM_TABS_PRESCRIPTIONS,
          loadChildren: () => import('./prescriptions/prescriptions.module').then((m) => m.PrescriptionsModule),
          canActivate: [MailOrderAccessGuard],
        },
        {
          path: 'drug', title: labels.LABEL_BOTTOM_TABS_DRUG_SEARCH,
          loadChildren: () => import('./drug/drug.module').then((m) => m.DrugModule)
        },
        {
          path: 'benefits', title: labels.LABEL_BOTTOM_TABS_PHARMACY_BENEFITS,
          loadChildren: () => import('./benefits/benefits.module').then((m) => m.BenefitsModule)
        },
        {
          path: 'find-pharmacy', title: labels.LABEL_BOTTOM_TABS_PHARMACY_SEARCH,
          loadChildren: () => import('./find-pharmacy/find-pharmacy.module').then((m) => m.FindPharmacyModule)
        },
        {
          path: 'help',
          loadChildren: () => import('./help/help.module').then((m) => m.HelpModule)
        },
        {
          path: 'membership', title: labels.LABEL_BOTTOM_TABS_PHARMACY_MEMBERSHIP,
          loadChildren: () => import('./membership/membership.module').then((m) => m.MembershipModule)
        },
        { path: 'settings', loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule) },
        {
          path: 'cart', title: labels.LABEL_CART_HOME_CART_ITEMS,
          loadChildren: () => import('./cart/cart.module').then((m) => m.CartModule),
          canActivate: [MailOrderAccessGuard]
        },
        {
          path: 'alternate-therapy', title: labels.LABEL_MORE_ALTERNATE_THERAPY,
          loadChildren: () => import('./alternate-therapy/alternate-therapy.module').then((m) => m.AlternateTherapyModule)
        },
        {
          path: 'forms', title: labels.LABEL_FORMS,
          loadChildren: () => import('./custom-forms/custom-forms.module').then((m) => m.CustomFormsModule)
        },
        {
          path: 'clinical-reviews', title: labels.LABEL_MORE_CLINICAL_REVIEW,
          loadChildren: () => import('./clinical-reviews/clinical-reviews.module').then((m) => m.ClinicalReviewsModule)
        },
        {
          path: 'pmart-patient-enrollment', title: labels.LABEL_PMART_ENROLLMENT_FORM_TITLE,
          component: PmartPatientEnrollmentFormComponent
        }
      ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }
